import { Box, Stack } from "@mui/material";
import AuthLeftBlue from "components/screen/phase-3/AuthLeftRight/AuthLeftBlue";
import AuthRightWrap from "components/screen/phase-3/AuthLeftRight/AuthRightWrap";
import LoginForm from "components/widgets/phase-3/AuthRight/RightLogin/LoginForm";
import SignupLoginHead from "components/widgets/phase-3/AuthRight/SignupLoginHead";

const LoginContainer = () => {
  return (
    <Box width={"100%"} height={"100vh"} display={"flex"}>
      <AuthLeftBlue sx={{ display: { xs: "none", md: "block" } }} />
      <AuthRightWrap>
        <Stack
          width={"100%"}
          height={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          sx={{ p: { xs: 5, md: 15 } }}
        >
          {/* Main Box */}
          <Stack spacing={4} width={"100%"}>
            {/* Form Section */}
            <Stack spacing={2}>
              {/* Head */}
              <SignupLoginHead head={"Login to your Company"} />
            </Stack>

            {/* Form */}
            <LoginForm />
          </Stack>
        </Stack>
      </AuthRightWrap>
    </Box>
  );
};
export default LoginContainer;
